// My members is for churches to see who their members are and remove if necessary later we will be able to message them from here too
import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Loader from "loaders/Loader";
import { SettingsMainContainer } from '../settings.styled'
import MyMembersItem from './MyMembersItem';
import { getMembers, mbsReset } from '../../../features/memberships/membershipSlice'
import './members.css'
import MemberSearch from './MemberSearch';
import styled from 'styled-components';
import GroupsIcon from '@mui/icons-material/Groups';

import { Modal } from '@mui/material';
import ConfirmModal from 'components/modals/ConfirmModal';
import { setViewConfirmModal } from 'features/modal/modalSlice';
import MemberRolesPanel from './MemberRolesPanel';
import { useTranslation } from 'react-i18next'



function MyMembers(props) {
  const { t: translate } = useTranslation()
  const dispatch = useDispatch()
  const [loadingMore, loadingMoreSet] = useState()
  const { user } = useSelector((state) => state.auth)
  const {  
    members, 
    isMemberSearchActive, 
    isMbsLoading, 
    isMbsSuccess, 
    totalMembers,
    filter,
    hasNextPage,
    nextPage,
    searchResults

  } = useSelector((state) => state.memberships2)


  const { viewConfirmModal, confirmModalData } = useSelector((state) => state.modal)

  useEffect(()=> {
    // NOTE: here we can think of a way to optimize the data retrieval
    dispatch(getMembers({
      page: 1,
      filter: filter
    }))  

  }, [dispatch])


  useEffect( () => () => { //cleanup
    dispatch(mbsReset())
  }, [] ); 


  const handleLoadMore  = () => {
    if(hasNextPage){

      loadingMoreSet(true)
      dispatch(getMembers({
        page: nextPage,
        filter: filter
      }))
    }
  }

  return (
      <SettingsMainContainer>

        <ManageHeader>
          <div>
            <ManageTitle>{translate("web:settings.memberManagement")}</ManageTitle>
            <ManageSubTitle>
              {translate('settings:membership.manageHelp')}
            </ManageSubTitle>
          </div>
        </ManageHeader>

        <MemberTopContainer>
          <MemberSearch />

          {
              isMbsSuccess && (
                <MemberCount>  
                  {
                    translate("web:settings.members")
                  }: 
                   {' ' + totalMembers} 
                </MemberCount>                
              )
            }

          </MemberTopContainer>

        <MemberRolesPanel />

        <MemberItemContainer>
          
          {
                isMbsLoading && !loadingMore ? 
                (
                  <Loader />
                )
                : isMbsSuccess ?
                ( members.map((member, index) => {
                  let min = 1
                  const max = 100
                  const rand = min + Math.random() * (max - min)
                  return (
                      <MyMembersItem
                          key={ member._id +  rand } 
                          index={index}
                          userId={member._id} 
                          fullName={member.fullName} 
                          image={member.profileImg?.url || member.profileImg?.urlSmall || ''}  
                          email={member.email}
                      />
                  )
                })
                )
                :
                (
                  <div>{translate('settings:membership.loadError')}</div>
                )
          }
          {hasNextPage ? 
            (
              <LoadMoreBtn onClick={handleLoadMore}>
                {
                  translate("web:settings.loadMore")
                }
              </LoadMoreBtn>
            )
            : !isMemberSearchActive && !hasNextPage && members.length === 0 ?
            (
              <div className='noRequestsWrap'>
                <div> <GroupsIcon className="noRequestsIcon" /></div>
                <div className='noRequests'>
                  {
                    translate("web:settings.noMembers")
                  }
                </div>
              </div>
            )
            : isMemberSearchActive && searchResults.length === 0 &&
            (
              <div
                style={{
                  color: 'grey',
                }}
                >
                  {
                    translate("web:settings.noSearchResults")
                  }
                </div>
            )
          }
          </MemberItemContainer>
          

          <Modal
            open={viewConfirmModal}
            style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClose={() => dispatch(setViewConfirmModal(false))}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
          <ConfirmModal 
            text={confirmModalData.text} 
            handler={confirmModalData.handler} 
            confirmBtnBackgroundHover={confirmModalData.confirmBtnBackgroundHover}
            extraInfo={confirmModalData.extraInfo}
            /> 
          </Modal>
      </SettingsMainContainer>
  )
}

const MemberTopContainer = styled.div`
  width: 100%;
  display: flex; 
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 0 20px 14px;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;

    span{
      margin-bottom: 10px;
      font-size: 12px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
    }
  }

`

const ManageHeader = styled.div`
  width: 100%;
  padding: 20px 20px 14px;
  color: var(--lightThemeFontColor);
`

const ManageTitle = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  font-family: 'Roboto', sans-serif;
`

const ManageSubTitle = styled.p`
  margin: 8px 0 0;
  max-width: 680px;
  color: var(--dFontColor);
  font-size: 13px;
  line-height: 1.45;
  font-family: 'Roboto', sans-serif;
`

const MemberCount = styled.span`
  min-width: fit-content;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(0, 180, 204, 0.1);
  border: 1px solid rgba(0, 180, 204, 0.22);
  color: var(--themeColor);
  font-size: 12px;
  font-weight: 700;
`

const LoadMoreBtn = styled.div`
  padding: 6px 40px;
  background-color: #00800094;
  border-radius: 5px;
  color: white;
  width: 50%;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  cursor: pointer;
`
const MemberItemContainer = styled.div`
  padding: 0 20px 20px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: auto;
  gap: 8px;

  @media (max-width: 768px) {
    padding: 0 10px 16px;
  }
`

export default MyMembers
